<template>
    <client-page>
        <section class="section">
            <v-container>
                <!-- Mobile -->
                <v-img src="/images/sub/campaign/one-meal/mobile.jpg" class="campaign-view campaign-view--mobile">
                    <template v-for="(btn, index) in buttonList">
                        <a :key="index" :href="buttonlink" target="_blank" class="campaign-view__button" :class="`campaign-view__button--${btn}`">{{ buttonText }}</a>
                    </template>
                </v-img>
                <!--// Mobile -->

                <!-- PC -->
                <v-img src="/images/sub/campaign/one-meal/image.jpg" class="campaign-view campaign-view--pc">
                    <template v-for="(btn, index) in buttonList">
                        <a :key="index" :href="buttonlink" target="_blank" class="campaign-view__button" :class="`campaign-view__button--${btn}`">{{ buttonText }}</a>
                    </template>
                </v-img>
                <!--// PC -->
                <div class="mt-40 mt-lg-60">
                    <v-row justify="end" class="row--x-small">
                        <v-col cols="auto">
                            <!-- <v-btn @click="$router.go(-1)" outlined color="grey-9">목록보기</v-btn> -->
                            <v-btn to="/news/campaign" outlined color="grey-9">목록보기</v-btn>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
    },
    data: () => ({
        buttonList: ["top"],

        buttonlink: "https://secure.donus.org/withcan/pay/step1?_gl=1*180luv6*_ga*MTY5ODQ1OTg0Mi4xNzE3NDY4Mzcy*_ga_1KFQVNYJMP*MTczNjc1MjExNi4xMzAuMC4xNzM2NzUyMTE2LjYwLjAuMA",
        buttonText: "아이들 후원하기",
    }),
};
</script>

<style lang="scss" scoped>
.campaign-view {
    --image-width: 720;
    --image-height: 17876;
    position: relative;
    &--pc {
        display: none;
    }
    &__button {
        position: absolute;
        display: block;
    }
    &__button {
        width: calc(var(--button-width) / var(--image-width) * 100%);
        height: calc(var(--button-height) / var(--image-height) * 100%);
        border-radius: 999px;
        text-align: center;
        font-size: 1rem;
        opacity: 0;
        &--top {
            --button-width: 416;
            --button-height: 96;
            --button-top-x: 152;
            --button-top-y: 548;
            left: calc(var(--button-top-x) / var(--image-width) * 100%);
            top: calc(var(--button-top-y) / var(--image-height) * 100%);
        }
    }
}

@media (min-width: 723px) {
    .campaign-view {
        --image-width: 1200;
        --image-height: 8708;
        &--mobile {
            display: none;
        }
        &--pc {
            display: block;
        }
        &__button {
            &--top {
                --button-width: 208;
                --button-height: 48;
                --button-top-x: 160;
                --button-top-y: 420;
            }
        }
    }
}
</style>
